
import Hero from './components/Hero';
import Treatments from './components/Treatments';
import Procedures from './components/Procedures';
import About from './components/About';
import Locations from './components/Locations';
import Insurance from './components/Insurance';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white font-['Inter']">
      <Header />
      <Hero />
      <Treatments />
      <Procedures />
      <About />
      <Locations />
      <Insurance />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
}
